// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RefObject, useEffect, useState } from "react";

const useRowOverlap = (ref: RefObject<HTMLDivElement | null>, allowOverlap: boolean) => {
    const [canOverlap, setCanOverlap] = useState(false);

    const calculation = (entry: ResizeObserverEntry) => {
        const noOverlapElements = entry.target.parentElement?.querySelectorAll(".no-overlap");
        const overlapElement = entry.target;

        if (!overlapElement || !noOverlapElements) {
            return;
        }

        const extraOffset = 20;
        const overlapValue = parseInt(overlapElement.getAttribute("data-overlap") || "0", 10) / 100;

        const minElementHeight = entry.contentRect.height * overlapValue + extraOffset;

        let canOverlap = true;
        noOverlapElements.forEach(element => {
            if (element.clientHeight > minElementHeight) {
                canOverlap = false;
            }
        });

        setCanOverlap(canOverlap);
    };

    useEffect(() => {
        if (!ref.current || !allowOverlap) {
            return;
        }

        const overlapElement = ref.current?.querySelector(".overlap");
        if (!overlapElement) {
            return;
        }

        const observer = new (window as any).ResizeObserver(([entry]: ResizeObserverEntry[]) => {
            setTimeout(() => {
                calculation(entry);
            }, 0);
        });

        observer.observe(overlapElement);

        return () => observer.disconnect();
    }, []);

    return canOverlap;
};

export default useRowOverlap;
